import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Select: React.FC = () => {
  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold text-navy">Select Program</h1>
        <p className="lead text-muted">Competitive Soccer for U11 and Older</p>
        <hr className="w-25 mx-auto text-teal" style={{ opacity: 1, height: '3px' }} />
      </div>

      <div className="alert alert-success text-center shadow-sm border-0 mb-5">
        <h4 className="fw-bold mb-2">Now Accepting Player Interest for Fall 2026-27</h4>
        <p className="mb-3">
          We are gathering interest from players who'd like to join us for the upcoming season.
          We will reach out to interested players individually about chances to practice
          with us and try us out &mdash; <strong>we will not be posting a formal tryout schedule.</strong>
        </p>
        <Button
          variant="primary"
          size="lg"
          href="https://forms.gle/fM3781HwpHVgDdy68"
          target="_blank"
          rel="noreferrer"
          className="text-white fw-bold"
        >
          Submit 2026-27 Interest Form
        </Button>
      </div>

      <Row className="mb-5">
        <Col lg={8} className="mx-auto text-center">
          <h2 className="fw-bold text-navy mb-4">"We aren't recruiting players, we are building players!"</h2>
          <p className="lead">
            Our Select program is for players who want to compete at a higher level in the Iowa Soccer State League. 
            We focus on long-term development, tactical understanding, and team cohesion.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={6}>
            <div className="bg-white p-4 h-100 shadow-sm border-start border-5 border-primary">
                <h3 className="text-navy fw-bold mb-3">How We Welcome New Players</h3>
                <p><strong>We do NOT hold traditional tryouts &mdash; and there is no formal tryout schedule to watch for.</strong></p>
                <p>
                    After you submit the interest form above, a coach will be in touch directly to invite
                    your player to practice with us. These open practices let your player experience our
                    coaching style and culture ("Try US out") while we get to know them and find the right
                    fit for the upcoming season.
                </p>
                <div className="alert alert-info mb-0">
                    <strong>Primary Location:</strong> Southeast Polk Junior High Turf
                </div>
            </div>
        </Col>
        <Col md={6} className="mt-4 mt-md-0">
             <div className="bg-navy text-white p-4 h-100 shadow-sm rounded">
                <h3 className="fw-bold mb-3 text-white">Program Highlights</h3>
                <ul className="list-unstyled">
                    <li className="mb-2">✅ <strong>League Play:</strong> Iowa Soccer State League (ISSL)</li>
                    <li className="mb-2">✅ <strong>Tournaments:</strong> 1 In-state + 1 Out-of-state per season</li>
                    <li className="mb-2">✅ <strong>Training:</strong> High-frequency, quality sessions with licensed coaches</li>
                    <li className="mb-2">✅ <strong>Video Analysis:</strong> Veo camera technology for team review</li>
                    <li className="mb-2">✅ <strong>Cost:</strong> ~$750/year (Tiered financial aid available)</li>
                </ul>
             </div>
        </Col>
      </Row>

      <h3 className="fw-bold text-center mb-4">Current Teams (2025-26)</h3>
      <Row className="g-4 justify-content-center">
        <Col md={4}>
          <Card className="h-100 text-center border-0 shadow-sm">
            <Card.Header className="bg-teal text-white fw-bold">Girls</Card.Header>
            <Card.Body>
              <Card.Title>U13 / U14 Select</Card.Title>
              <Card.Text>Competitive team focused on tactical growth and speed of play.</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 text-center border-0 shadow-sm">
            <Card.Header className="bg-navy text-white fw-bold">Boys</Card.Header>
            <Card.Body>
              <Card.Title>U11 Select</Card.Title>
              <Card.Text>Foundational competitive team building core technical skills.</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="mt-5 text-center">
        <p className="text-muted">Ready to take the next step for the 2026-27 season?</p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
            <Button
              href="https://forms.gle/fM3781HwpHVgDdy68"
              target="_blank"
              rel="noreferrer"
              size="lg"
              variant="primary"
              className="text-white"
            >
              Submit Interest Form
            </Button>
            <Button href="mailto:info@515soccer.org" size="lg" variant="outline-primary">Contact Us</Button>
        </div>
      </div>
    </Container>
  );
};

export default Select;
